/* globals cision, moment, queryObj */

$(function () {
	'use strict';

    $.support.cors = true;
    var defaultLang = 'en';

	if (cision.websolution) {
        cision.websolution.cisionHandler = $('html').data('cision-url');
        if ($('html').attr('lang') == 'sv' || $('html').attr('lang') == 'en' ) {    
            cision.uiLanguage = $('html').attr('lang');
        } else {
            cision.uiLanguage = defaultLang;
        }
		//cision.uiLanguage = ($('html').attr('lang') === 'en' || 'sv') ? $('html').attr('lang') : 'en';

		if ($('#cision-insiders-listing').length) {
			cision.websolution.insiders.renderToGraph({
				// accessKey: '0C9AD8114C9E427D8709F3AD693D62EC',
				uiLanguage: cision.uiLanguage,
				startDate: moment().subtract(1, 'years').format('YYYY-MM-DD')
			});
		}

		if ($('#cision-insider-details').length) {
			cision.websolution.insiders.renderTransactionsList({
				insiderName: queryObj().insiderName,
				startDate: moment().subtract(1, 'years').format('YYYY-MM-DD')
			});
		}

		if ($('#template-estimate-annual').length) {
			cision.websolution.estimate.annual.render({
				periodStart: (moment().year() - 2).toString(),
				periodEnd: moment().year() + 1
			});
		}

		if ($('#template-estimate-quarterly').length) {
			cision.websolution.estimate.quarterly.render({
				periodStart: (moment().year() - 1).toString() + '-Q3',
				periodEnd: (moment().year() + 1) + '-Q4' // '2014-Q4'
			});
		}

		if ($('#target-estimate-historical').length) {
			cision.websolution.estimate.historical.render({
				chartTitle: 'SALES, MSEK',
				valuePrefix: '',
				valueSuffix: ' MSEK',
				dateFormatTooltip: 'llll'
			});
		}

		if ($('#tplShareInformation').length) {
			cision.websolution.estimate.recommendations.renderTicker({
				dateFormat: 'llll'
			});
		}

		if ($('#historicRecommendation').length) {
			cision.websolution.estimate.recommendations.renderHistory({
				startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
				endDate: moment().format('YYYY-MM-DD')
			});
		}

		if ($('#tplCurrentRecommendationDistribution').length) {
			cision.websolution.estimate.recommendations.renderCurrent({
				dateFormat: 'llll'
			});
		}

		$('#target-estimate-historical .historical-tab').on('click', function (e) {
			e.preventDefault();
			var fieldType = $(this).attr('id');
			var valuePrefix = '';
			var valueSuffix = '';
			var chartTitle = '';

			switch (fieldType) {
				case 'SALES':
					chartTitle = 'SALES, MSEK';
					valueSuffix = ' MT';
					break;

				case 'EBIT':
					chartTitle = 'EBIT, MSEK';
					valueSuffix = ' MSEK';
					break;

				case 'DPS':
					chartTitle = 'DPS, SEK';
					valueSuffix = ' SEK';
					break;

				case 'EPS':
					chartTitle = 'EPS, SEK';
					valueSuffix = ' SEK';
					break;

				default:
					break;
			}

			cision.websolution.estimate.historical.render({
				field: fieldType,
				chartTitle: chartTitle,
				valuePrefix: valuePrefix,
				valueSuffix: valueSuffix
			});

			$('#target-estimate-historical .historical-tab').removeClass('active');
			$(this).addClass('active');
		});
	}
});